export default __webpack_public_path__ + "static/media/logo.589e5b44.png";